import { c as _c } from "react/compiler-runtime";
import { SimpleGrid, SimpleGridProps, StackProps, VStack } from '@chakra-ui/react';
import { HomeAskBarProps } from '@src/components/sco/Home/HomePaths/HomeAskBar';
import { HomePathCard } from '@src/components/sco/Home/HomePaths/HomePathCard';
import { DEFAULT_HOME_PATHS, HomePathItem } from '@src/components/sco/Home/HomePaths/homePaths';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export type { HomePathCardProps } from '@src/components/sco/Home/HomePaths/HomePathCard';
export { HomePathCard } from '@src/components/sco/Home/HomePaths/HomePathCard';
export type { HomeAskBarProps } from '@src/components/sco/Home/HomePaths/HomeAskBar';
export { HomeAskBar } from '@src/components/sco/Home/HomePaths/HomeAskBar';
export type { HomePathItem } from '@src/components/sco/Home/HomePaths/homePaths';
export { DEFAULT_HOME_PATHS } from '@src/components/sco/Home/HomePaths/homePaths';
export { AdvisorsPathIllustration, CustomersPathIllustration, FundingPathIllustration, PitchDeckPathIllustration } from '@src/components/sco/Home/HomePaths/illustrations';
export type HomePathsProps = {
  paths?: HomePathItem[];
  /** Hide the ask bar above the path cards. */
  children?: React.ReactNode;
  hideAskBar?: boolean;
  askBarProps?: Omit<HomeAskBarProps, 'containerProps'>;
  askBarContainerProps?: StackProps;
  containerProps?: StackProps;
  gridProps?: SimpleGridProps;
};

/**
 * Home hero product paths: optional ask bar above four path cards
 * (Pitch Deck, Funding, Advisors, Customers). Ported from homepage.html.
 */
export const HomePaths: React.FC<HomePathsProps> = t0 => {
  const $ = _c(25);
  const {
    children,
    paths: t1,
    hideAskBar: t2,
    containerProps,
    gridProps
  } = t0;
  const paths = t1 === undefined ? DEFAULT_HOME_PATHS : t1;
  t2 === undefined ? false : t2;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t3;
  if ($[0] !== getBreakpointValue) {
    t3 = getBreakpointValue([3, 4, 8]);
    $[0] = getBreakpointValue;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const pathsPaddingX = t3;
  let t4;
  if ($[2] !== getBreakpointValue) {
    t4 = getBreakpointValue([3, 4, 8]);
    $[2] = getBreakpointValue;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const pathsPaddingY = t4;
  let t5;
  if ($[4] !== getBreakpointValue) {
    t5 = getBreakpointValue([4, 4, 6]);
    $[4] = getBreakpointValue;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const pathsGap = t5;
  let t6;
  if ($[6] !== getBreakpointValue) {
    t6 = getBreakpointValue(["2xl", "3xl", "4xl", "4xl"]);
    $[6] = getBreakpointValue;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const pathsRadius = t6;
  let t7;
  if ($[8] !== getBreakpointValue) {
    t7 = getBreakpointValue([3, 4, 4]);
    $[8] = getBreakpointValue;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const gridGap = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      base: 1,
      sm: 2,
      lg: 3
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== paths) {
    t9 = paths.map(_temp);
    $[11] = paths;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== gridGap || $[14] !== gridProps || $[15] !== t9) {
    t10 = <SimpleGrid columns={t8} gap={gridGap} width="full" marginX="auto" {...gridProps}>{t9}</SimpleGrid>;
    $[13] = gridGap;
    $[14] = gridProps;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== children || $[18] !== containerProps || $[19] !== pathsGap || $[20] !== pathsPaddingX || $[21] !== pathsPaddingY || $[22] !== pathsRadius || $[23] !== t10) {
    t11 = <VStack align="stretch" bgGradient="to-b" borderColor="colorPalette.border" borderTopRadius={pathsRadius} borderTopWidth="1px" gap={pathsGap} gradientFrom="colorPalette.container/70" gradientTo="transparent" marginX="auto" maxWidth="5xl" paddingX={pathsPaddingX} paddingY={pathsPaddingY} width="full" {...containerProps}>{children}{t10}</VStack>;
    $[17] = children;
    $[18] = containerProps;
    $[19] = pathsGap;
    $[20] = pathsPaddingX;
    $[21] = pathsPaddingY;
    $[22] = pathsRadius;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
export default HomePaths;
function _temp(path) {
  return <HomePathCard key={path.id} ctaLabel={path.ctaLabel} description={path.description} href={path.href} illustration={path.illustration} proofLabel={path.proofLabel} proofValue={path.proofValue} title={path.title} />;
}